import { Link } from 'react-router-dom';

// Términos y Condiciones — borrador completo (2026-09-16).
// Contexto: Venezuela. Redactado genéricamente para adaptación por asesoría legal.
// Marcadores [NOTA LEGAL: ...] señalan puntos que requieren decisión/criterio legal.

const BANNER = (
  <div className="mb-8 rounded-xl border-2 border-dashed border-amber-400 bg-amber-50 px-4 py-3 text-sm text-amber-800">
    <strong>BORRADOR — pendiente de revisión legal.</strong> Este documento es un
    borrador de trabajo genérico; no constituye asesoría legal y debe ser revisado
    y adaptado por un profesional del derecho antes de considerarse definitivo.
  </div>
);

export default function Terms() {
  return (
    <div className="min-h-full bg-white">
      {/* Header */}
      <header className="border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center gap-2">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
                <rect width="40" height="40" rx="10" fill="#36CCD8"/>
                <path d="M20 8L6 22L12 28L20 20L28 28L34 22L20 8Z" fill="white"/>
                <path d="M20 16L12 24L16 28L20 24L24 28L28 24L20 16Z" fill="white" fillOpacity="0.4"/>
              </svg>
              <span className="text-xl font-bold text-gray-900">Vecindus</span>
            </Link>
            <Link
              to="/login"
              className="px-4 py-2 text-[#36CCD8] font-semibold hover:text-[#2DB8C4] transition-colors"
            >
              Iniciar sesión
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {BANNER}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Términos y Condiciones</h1>
        <p className="text-sm text-gray-500 mb-8">
          Última actualización: Septiembre 2026 (lote legal 2026-09-29).{' '}
          <Link to="/privacidad" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2 font-medium">
            Consulta también nuestra Política de Privacidad →
          </Link>
        </p>

        <div className="prose prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Aceptación de los términos</h2>
            <p className="text-gray-600 mb-4">
              Estos Términos y Condiciones (&laquo;los Términos&raquo;) regulan el acceso y uso de la
              plataforma Vecindus, sus aplicaciones web y móviles, y los servicios de gestión de
              condominios y control de accesos que se prestan a través de ellos (en conjunto, el
              &laquo;Servicio&raquo;).
            </p>
            <p className="text-gray-600 mb-4">
              Al crear una cuenta, aceptar una invitación, utilizar el Servicio o marcar la casilla
              de aceptación correspondiente, declaras haber leído, entendido y aceptado estos
              Términos y nuestra{' '}
              <Link to="/privacidad" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2">
                Política de Privacidad
              </Link>
              , que forma parte integrante de este contrato.
            </p>
            <p className="text-gray-600">
              Si utilizas el Servicio en nombre de una entidad (por ejemplo, como administrador o
              directivo de un condominio), declaras contar con facultad para vincular a dicha
              entidad, la cual también quedará sujeta a estos Términos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Descripción del servicio</h2>
            <p className="text-gray-600 mb-4">
              Vecindus es una plataforma digital de gestión de condominios y comunidades que
              proporciona herramientas para:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Administración de edificios, unidades y residentes.</li>
              <li>Gestión de cuotas de mantenimiento, cobros y estados de cuenta.</li>
              <li>Control de accesos, emisión de pases QR y registro de visitantes.</li>
              <li>Comunicación entre administración, residentes y personal de seguridad.</li>
              <li>Gestión de amenidades y reservas de espacios comunes.</li>
            </ul>
            <p className="text-gray-600 mt-4">
              Vecindus es un proveedor de software: facilita herramientas a los administradores de
              cada condominio, pero <strong>no gestiona el condominio ni es responsable de las
              decisiones administrativas, cobros internos o medidas de seguridad física</strong> que
              corresponden a la administración o junta de condominio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Tipos de usuarios</h2>
            <p className="text-gray-600 mb-4">El Servicio distingue los siguientes perfiles de usuario:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>
                <strong>Administradores y directivos:</strong> personas designadas por el condominio
                para configurar el Servicio, gestionar unidades, residentes, cobros y reportes.
                Actúan como responsables del tratamiento de los datos de su propio condominio
                conforme a la Política de Privacidad.
              </li>
              <li>
                <strong>Residentes:</strong> propietarios o inquilinos vinculados a una unidad, con
                acceso a información de su unidad, pagos, comunicaciones y herramientas de visitas.
              </li>
              <li>
                <strong>Familiares y cohabitantes:</strong> usuarios autorizados por un residente
                con permisos limitados a su unidad.
              </li>
              <li>
                <strong>Personal de seguridad / vigilancia:</strong> usuarios designados por el
                condominio que operan el control de accesos, validan pases QR y registran ingresos
                de visitantes.
              </li>
              <li>
                <strong>Proveedores y contratistas:</strong> usuarios autorizados por la
                administración para acceso limitado relacionado con servicios al condominio.
              </li>
              <li>
                <strong>Invitados / visitantes:</strong> personas que no poseen cuenta y cuyo acceso
                se gestiona mediante pases o autorizaciones emitidas por un residente o la
                administración (ver sección 6).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Mayores de 18 años</h2>
            <p className="text-gray-600 mb-4">
              El Servicio está dirigido exclusivamente a <strong>personas mayores de 18 años</strong>.
              No está destinado a menores de edad y no recopilamos intencionalmente sus datos.
            </p>
            <p className="text-gray-600">
              Las cuentas pueden pertenecer asimismo a <strong>juntas de condominio o
              administraciones como personas jurídicas</strong>; en ese caso, la persona que opera
              la cuenta en nombre de la entidad declara ser mayor de edad y contar con facultad
              para actuar en su representación.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Suscripciones y pagos</h2>
            <p className="text-gray-600 mb-4">
              Para utilizar ciertas funciones debes registrarte con un nombre, correo electrónico y
              contraseña, y verificar tu dirección de correo. Tú eres responsable de:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Mantener la confidencialidad de tu contraseña y de los dispositivos donde accedes.</li>
              <li>Toda actividad que ocurra bajo tu cuenta.</li>
              <li>Notificar de inmediato a soporte ante cualquier uso no autorizado.</li>
              <li>Proporcionar información veraz y mantenerla actualizada.</li>
            </ul>
            <p className="text-gray-600 mt-4">
              Aplicamos medidas de seguridad razonables, incluido el almacenamiento de contraseñas
              mediante cifrado (hash) con bcrypt y el uso de enlaces de verificación y códigos de
              un solo uso con expiración limitada. No obstante, ninguna medida garantiza seguridad
              absoluta; no compartiremos contigo la responsabilidad por compromisos causados por el
              descuido de tus credenciales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5.1 Cuentas y seguridad</h2>
            <p className="text-gray-600 mb-4">
              <strong>5.1 Planes.</strong> El Servicio se ofrece a los condominios mediante planes
              de suscripción, cuyo precio puede calcularse por unidad habitacional o por condominio,
              según el plan contratado. Las características y precios vigentes se describen en la
              página de precios dentro de la plataforma.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.2 Renovación.</strong> Las suscripciones se renuevan automáticamente por
              períodos equivalentes al contratado (mensual o anual), salvo cancelación previa por
              parte del condominio o Vecindus.{' '}
              <em>[NOTA LEGAL: definir período de preaviso para no renovación.]</em>
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.3 Cancelación.</strong> La administración del condominio puede cancelar su
              suscripción desde el panel de facturación o escribiendo a soporte. La cancelación
              evita futuras renovaciones; el acceso permanece activo hasta el final del período ya
              pagado.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.4 Reembolsos.</strong> Los pagos de suscripción no son reembolsables una vez
              iniciado el período, salvo error comprobado de facturación o disposición legal
              aplicable. <em>[NOTA LEGAL: política de reembolsos definitiva por definir.]</em>
            </p>
            <p className="text-gray-600 mb-4">
              <strong>5.5 Cambios de precio.</strong> Podemos ajustar los precios de los planes con
              aviso previo razonable antes de la siguiente renovación; el uso continuado del
              Servicio tras la renovación implica la aceptación del nuevo precio.
            </p>
            <p className="text-gray-600">
              <strong>5.6 Cobros de condominio.</strong> Los cobros de cuotas de mantenimiento que
              los administradores generan a través de la plataforma corresponden exclusivamente a la
              relación entre el condominio y sus residentes. Vecindus no es parte de dichas
              obligaciones y los pagos, cuando se procesen en línea, están sujetos a los términos de
              los procesadores de pago terceros integrados.{' '}
              <em>[NOTA LEGAL: verificar regulación aplicable a procesamiento de pagos y servicios
              electrónicos en Venezuela.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Suscripciones, precios y renovación</h2>
            <p className="text-gray-600 mb-4">
              <strong>6.1 Precios.</strong> Los planes se facturan por el período contratado.
              Precio: <strong>[TODO: confirmar precio y moneda por plan antes de activar cobros —
              los pagos aún no están lanzados]</strong>. Período de facturación:{' '}
              <strong>[TODO: mensual/anual según plan]</strong>.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>6.2 Renovación automática.</strong> La suscripción se renueva automáticamente
              al final de cada período de facturación, por períodos sucesivos equivalentes, salvo
              cancelación previa. El cobro de cada renovación se efectúa mediante el medio de pago
              registrado por el condominio.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>6.3 Cancelación en un clic.</strong> La administración puede cancelar la
              renovación automática en cualquier momento, con un clic, desde el panel de
              facturación (o escribiendo a soporte). La cancelación evita futuras renovaciones; el
              acceso permanece activo hasta el final del período ya pagado.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>6.4 Reembolsos y cambios de precio.</strong> Los períodos iniciados no son
              reembolsables salvo error comprobado de facturación. Los cambios de precio se
              comunican con aviso previo razonable antes de la siguiente renovación.{' '}
              <em>[NOTA LEGAL: política de reembolsos definitiva por definir.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Invitaciones de visitantes y pases QR</h2>
            <p className="text-gray-600 mb-4">
              <strong>7.1 Responsabilidad del anfitrión.</strong> El residente que emite una
              invitación o pase de acceso para un invitado declara que dicha persona está autorizada
              a ingresar, y es responsable de su conducta dentro del condominio y de la veracidad de
              los datos proporcionados (nombre, placa del vehículo u otros que solicite la
              administración). Vecindus no autoriza ni supervisa el ingreso de visitantes; quien
              autoriza es el anfitrión o la administración del condominio.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>7.2 Datos de visitantes.</strong> El registro de un visitante puede incluir su
              nombre, el pase o código QR, la placa del vehículo y la fecha y hora de ingreso y
              salida, con fines de seguridad y control de accesos. Estos datos se comparten con el
              personal de seguridad del condominio para validar el acceso. El anfitrión debe informar
              al invitado del registro de estos datos cuando resulte exigible.
            </p>
            <p className="text-gray-600 mb-4">
              <strong>7.3 Acceso sin invitación previa (walk-in).</strong> El condominio puede
              habilitar el registro de visitas espontáneas directamente por el personal de seguridad
              en portería. En tal caso, la administración del condominio es responsable de dicho
              registro y de las autorizaciones correspondientes.{' '}
              <em>[NOTA LEGAL: definir política y configuración por condominio para walk-ins.]</em>
            </p>
            <p className="text-gray-600">
              <strong>7.4 Uso indebido de pases.</strong> Los pases son personales, de un solo uso
              cuando así se indique, y no deben revenderse, transferirse ni manipularse. El
              condominio o Vecindus pueden desactivar pases ante sospecha de fraude o abuso.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Uso aceptable</h2>
            <p className="text-gray-600 mb-4">Te comprometes a no utilizar el Servicio para:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Fines ilícitos, fraudulentos o lesivos a derechos de terceros.</li>
              <li>Acosar, hostigar o amenazar a otros usuarios o visitantes.</li>
              <li>Acceder, consultar o alterar datos de otros condominios o usuarios sin autorización.</li>
              <li>Interferir, sobrecargar o intentar vulnerar la seguridad de la plataforma.</li>
              <li>Manipular pases QR, códigos o registros de acceso, o suplantar identidades.</li>
              <li>Extraer datos masivamente (scraping) o revender el Servicio sin autorización.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Propiedad intelectual</h2>
            <p className="text-gray-600">
              El software, diseño, marcas, logotipos y contenidos de Vecindus son propiedad de su
              titular y están protegidos por la legislación de propiedad intelectual aplicable. Se
              otorga a los usuarios una licencia limitada, revocable y no exclusiva para usar el
              Servicio conforme a estos Términos. Los datos que los condominios y residentes cargan
              en la plataforma siguen siendo de su titularidad; Vecindus los trata únicamente para
              prestar el Servicio conforme a la Política de Privacidad.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Exclusión de garantías y limitación de responsabilidad</h2>
            <p className="text-gray-600 mb-4">
              El Servicio se ofrece &laquo;tal cual&raquo; y &laquo;según disponibilidad&raquo;.
            </p>
            <div className="rounded-xl border-2 border-amber-400 bg-amber-50 px-4 py-3 text-sm text-amber-800 mb-4">
              <strong>Cláusula destacada — responsabilidad por accesos.</strong> Las decisiones de
              permitir o denegar el acceso a las instalaciones, incluido el uso de pases y códigos
              QR en portería, corresponden exclusivamente al condominio, su administración y su
              personal de seguridad. Vecindus es únicamente un proveedor de herramientas
              tecnológicas y <strong>no autoriza, valida ni supervisa ingresos físicos</strong>; en
              consecuencia, <strong>no es responsable de ingresos no autorizados</strong>, de la
              conducta de visitantes ni de fallas de portones o sistemas físicos de control.
            </div>
            <p className="text-gray-600 mb-4">
              En la máxima medida permitida por la ley aplicable, Vecindus no será responsable por:
              (a) daños indirectos, incidentales o lucro cesante; (b) decisiones administrativas,
              cobros o medidas de seguridad física adoptadas por la administración del condominio;
              (c) ingreso de personas no autorizadas, fallas de portones o sistemas físicos de
              control; ni (d) interrupciones temporales del Servicio por mantenimiento o causas ajenas.
            </p>
            <p className="text-gray-600">
              La responsabilidad total de Vecindus frente a un condominio cliente se limita, en
              todo caso, al monto efectivamente pagado por este en los doce (12) meses anteriores al
              hecho generador.{' '}
              <em>[NOTA LEGAL: verificar admisibilidad de cláusulas de limitación bajo la ley
              venezolana y/o la aplicable al prestador.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Suspensión y terminación</h2>
            <p className="text-gray-600 mb-4">
              Podemos suspender o cerrar una cuenta si detectamos uso contrario a estos Términos,
              indicios de fraude, falta de pago de la suscripción o requerimiento legal. Lo
              notificaremos cuando sea posible y legalmente admisible.
            </p>
            <p className="text-gray-600">
              El condominio puede dar por terminada su suscripción conforme a la sección 5.3. Al
              terminar, conservaremos los datos según lo descrito en la Política de Privacidad
              (retención y eliminación) y, a solicitud de la administración, procuraremos entregar
              la información de su condominio en formato razonable.{' '}
              <em>[NOTA LEGAL: definir alcance y plazo de exportación de datos al terminar contrato.]</em>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Modificaciones de los términos</h2>
            <p className="text-gray-600">
              Podemos actualizar estos Términos para reflejar cambios del Servicio o de la ley.
              Publicaremos la versión actualizada en esta página e indicaremos la fecha de la última
              actualización; cuando los cambios sean sustanciales, los notificaremos con aviso
              razonable dentro de la plataforma o por correo. El uso del Servicio después de la
              entrada en vigencia implica la aceptación de la versión modificada.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">13. Ley aplicable y resolución de controversias</h2>
            <p className="text-gray-600 mb-4">
              Estos Términos se rigen por las leyes de la República Bolivariana de Venezuela, sin
              perjuicio de normas imperativas del domicilio del usuario cuando resulten aplicables.
              <em> [NOTA LEGAL: confirmar ley y foro elegidos por la asesoría legal; considerar
              arbitraje, jurisdicción judicial y/o mecanismos de consumo.]</em>
            </p>
            <p className="text-gray-600">
              Cualquier controversia derivada de estos Términos se procurará resolver mediante
              negociación amistosa en un plazo de treinta (30) días; de no lograrse, se someterá a
              los tribunales o mecanismos de resolución que la asesoría legal determine.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">14. Disposiciones generales</h2>
            <p className="text-gray-600">
              Si alguna disposición de estos Términos resultara inválida, el resto seguirá vigente.
              La no exigencia oportuna de un derecho no implica su renuncia. No podrá ceder estos
              Términos ni su cuenta sin autorización escrita de Vecindus, salvo en caso de fusión o
              adquisición del condominio cliente.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">15. Contacto</h2>
            <p className="text-gray-600 mb-4">
              Para preguntas sobre estos Términos, escríbenos a{' '}
              <a href="mailto:info@vecindus.com" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2">
                info@vecindus.com
              </a>
              .
            </p>
            <p className="text-gray-600">
              Consulta cómo tratamos tus datos personales en nuestra{' '}
              <Link to="/privacidad" className="text-[#36CCD8] hover:text-[#2DB8C4] underline underline-offset-2 font-medium">
                Política de Privacidad
              </Link>
              .
            </p>
          </section>

          <p className="text-sm text-gray-400 mt-12">
            Última actualización: Septiembre 2026 — Borrador pendiente de revisión legal.
          </p>
        </div>
      </main>
    </div>
  );
}
